import React from 'react';
import {
  FiltersIcon,
  CircleCross,
  RefreshIcon,
} from 'AppSrc/core/components/common/svg-icons';
import { toggleItem } from 'AppSrc/core/utility-functions/array-fun';
import PropTypes from 'prop-types';
import { CrqListStatusFilter } from './crq-list-status-filter';
import { CrqListDateFilter } from './crq-list-date-filter';
import { CrqListEndDateFilter } from './crq-list-end-date-filter';
import { CrqListRaisedDateFilter } from './crq-list-raised-date-filter';
import { CrqListFilterTags } from './crq-list-filter-tags';
import { CrqListSlaFilter } from './crq-list-sla-filter';
import 'AppSrc/core/style/components/crqs-screen/crq-list-filters.css';
import { CrqListMyCRQFilter } from './crq-list-mycrq-filter';
import { CrqListCircuitCheckFilter } from './crq-list-circuit-check-filter';
import { CrqListFlightChangesFilter } from './crq-list-flightchanges-filter';


const SLA_STATE_KEY = 'selectedSlas';
const STATUS_STATE_KEY = 'selectedStatuses';
const CIRCUIT_CHECK_KEY = 'selectedReason';

class CrqListFilters extends React.Component {
  constructor(props) {
    super(props);
    const {
      selectedStatuses, selectedDate, selectedEndDate, selectedRaisedDate, selectedSlas, selectedMyCRQ, selectedReason, selectedFlight,
    } = this.getStateFilterValueFromProps();
    this.state = {
      open: false,
      selectedStatuses,
      selectedSlas,
      selectedDate,
      selectedEndDate,
      selectedRaisedDate,
      selectedReason,
      selectedMyCRQ,
      selectedFlight,
      enableFilterBtn: false,
    };
    this.toggleStatus = this.toggleStatus.bind(this);
    this.toggleSla = this.toggleSla.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.setDate = this.setDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    this.setRaisedDate = this.setRaisedDate.bind(this);
    this.toggleMyCrq = this.toggleMyCrq.bind(this);
    this.toggleFlight = this.toggleFlight.bind(this);
    this.toggleCircuitCheck = this.toggleCircuitCheck.bind(this);
    this.openPanel = this.openPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.clearDateTag = this.clearDateTag.bind(this);
    this.clearEndDateTag = this.clearEndDateTag.bind(this);
    this.clearRaisedDateTag = this.clearRaisedDateTag.bind(this);
    this.clearCheckboxTag = this.clearCheckboxTag.bind(this);
    this.clearSlaTag = this.clearSlaTag.bind(this);
    this.clearStatusTag = this.clearStatusTag.bind(this);
    this.clearMyCRQ = this.clearMyCRQ.bind(this);
    this.clearFlight = this.clearFlight.bind(this);
    this.clearSelectedReason = this.clearSelectedReason.bind(this);
  }

  setDate(selectedDate) {
    this.setState({ selectedDate });
    this.setState({ selectedDate, enableFilterBtn: true });
  }

  setEndDate(selectedEndDate) {
    this.setState({ selectedEndDate });
    this.setState({ selectedEndDate, enableFilterBtn: true });
  }

  setRaisedDate(selectedRaisedDate) {
    this.setState({ selectedRaisedDate });
    this.setState({ selectedRaisedDate, enableFilterBtn: true });
  }


  getStateFilterValueFromProps() {
    const {
      statuses, startDate, endDate, raisedDate, selectedSlas, isMyCRQSelected, isFlightSelected, selectedReason,
    } = this.props.currentFilters || {};
    return ({
      selectedStatuses: statuses || [],
      selectedDate: startDate || null,
      selectedEndDate: endDate || null,
      selectedRaisedDate: raisedDate || null,
      selectedSlas: selectedSlas || [],
      selectedMyCRQ: isMyCRQSelected || false,
      selectedFlight: isFlightSelected || false,
      selectedReason: selectedReason || [],
    });
  }

  // toggleMyCrq() {
  //   this.setState((prevState) => (
  //     { selectedMyCRQ: !prevState.selectedMyCRQ }
  //   ));
  // }
  toggleMyCrq() {
    this.setState((prevState) => {
      console.log('!prevState.selectedMyCRQ', !prevState.selectedMyCRQ);
      return ({ selectedMyCRQ: !prevState.selectedMyCRQ, enableFilterBtn: !prevState.selectedMyCRQ });
    });
  }

  toggleFlight() {
    this.setState((prevState) => {
      console.log('!prevState.selectedFlight', !prevState.selectedFlight);
      return ({ selectedFlight: !prevState.selectedFlight, enableFilterBtn: !prevState.selectedFlight });
    });
  }

  toggleCheckbox(stateKey, value) {
    this.setState((prevState) => {
      const prevList = prevState[stateKey];
      const newList = toggleItem(prevList, value);
      // return ({ [stateKey]: newList });
      return ({ [stateKey]: newList, enableFilterBtn: newList.length > 0 ? true : false });
    });
  }

  toggleStatus(status) {
    this.toggleCheckbox(STATUS_STATE_KEY, status);
  }

  toggleSla(sla) {
    this.toggleCheckbox(SLA_STATE_KEY, sla);
  }

  toggleCircuitCheck(reason) {
    this.toggleCheckbox(CIRCUIT_CHECK_KEY, reason);
  }


  openPanel() {
    this.setState({ open: true });
  }

  closePanel() {
    const initialFilters = this.getStateFilterValueFromProps();
    this.setState({
      ...initialFilters,
      open: false,
    });
  }

  applyFilters() {
    const {
      selectedStatuses, selectedDate, selectedEndDate, selectedRaisedDate, selectedSlas, selectedMyCRQ, selectedReason, selectedFlight,
    } = this.state;
    this.props.setFilters({
      statuses: selectedStatuses,
      startDate: selectedDate,
      endDate: selectedEndDate,
      raisedDate: selectedRaisedDate,
      slas: selectedSlas,
      isMyCRQSelected: selectedMyCRQ,
      isFlightSelected: selectedFlight,
      statusReason: selectedReason,
    });
    this.setState({ open: false });
  }

  clearFilters() {
    this.setState({
      selectedStatuses: [],
      selectedDate: null,
      selectedEndDate: null,
      selectedRaisedDate: null,
      selectedSlas: [],
      enableFilterBtn: false,
      selectedFlight: false,
      selectedMyCRQ: false,
      selectedReason: [],
    }, this.applyFilters); // call apply filters when state changed
  }

  clearDateTag() {
    this.setState(
      { selectedDate: null },
      // apply new filters after clearing date
      this.applyFilters,
    );
  }

  clearEndDateTag() {
    this.setState(
      { selectedEndDate: null },
      // apply new filters after clearing date
      this.applyFilters,
    );
  }


  clearRaisedDateTag() {
    this.setState(
      { selectedRaisedDate: null },
      // apply new filters after clearing date
      this.applyFilters,
    );
  }


  clearMyCRQ() {
    this.setState({ selectedMyCRQ: false }, this.applyFilters);
  }

  clearFlight() {
    this.setState({ selectedFlight: false }, this.applyFilters);
  }

  clearCheckboxTag(stateKey, value) {
    const prevList = this.state[stateKey];
    const newList = prevList.filter((item) => item !== value);
    this.setState(
      { [stateKey]: newList },
      // apply new filters after clearing the status
      this.applyFilters,
    );
  }

  clearStatusTag(status) {
    this.clearCheckboxTag(STATUS_STATE_KEY, status);
  }

  clearSlaTag(status) {
    this.clearCheckboxTag(SLA_STATE_KEY, status);
  }
  // needs to be checked what to pass once we starts getting data on filtering

  clearSelectedReason(statusReason) {
    this.clearCheckboxTag(CIRCUIT_CHECK_KEY, statusReason);
  }

  render() {
    const {
      open,
      selectedDate,
      selectedEndDate,
      selectedRaisedDate,
      selectedStatuses,
      selectedSlas,
      enableFilterBtn,
      selectedReason,
    } = this.state;
    const {
      showStatuses,
      listIsSearch,
      title,
    } = this.props;

    return (
      <div className="crq-filters">
        {open ? (
          <div className="crq-filters-open">
            <div className="crq-filters-open-section">
              <div className="page-content-inner">
                <div className="crq-filters-inputs">
                  <button
                    type="button"
                    className="crq-filters-close"
                    onClick={this.closePanel}
                  >
                    <CircleCross />
                  </button>
                  <h2>Filter by</h2>
                  <div className="crq-filters-inputs-container">
                    <div className="crq-filters-inputs-container new-added-filter">
                      <CrqListDateFilter
                        selectedDate={selectedDate}
                        setSelectedDate={this.setDate}
                      />
                      <CrqListEndDateFilter
                        selectedEndDate={selectedEndDate}
                        setSelectedEndDate={this.setEndDate}
                      />
                      <CrqListRaisedDateFilter
                        selectedRaisedDate={selectedRaisedDate}
                        setSelectedRaisedDate={this.setRaisedDate}
                      />
                    </div>
                    <CrqListSlaFilter
                      selectedSlas={selectedSlas}
                      toggleSla={this.toggleSla}
                    />
                    {showStatuses && (
                      <CrqListStatusFilter
                        selectedStatuses={selectedStatuses}
                        toggleStatus={this.toggleStatus}
                        listIsSearch={listIsSearch}
                      />
                    )}
                    <CrqListCircuitCheckFilter
                      selectedReason={selectedReason}
                      toggleCircuitCheck={this.toggleCircuitCheck}
                    />
                    <div className="crq-filters-inputs-container new-added-filter">
                      <CrqListMyCRQFilter
                        isSelected={this.state.selectedMyCRQ}
                        toggleMyCRQ={this.toggleMyCrq}
                      />
                      <CrqListFlightChangesFilter
                        isSelected={this.state.selectedFlight}
                        toggleFlight={this.toggleFlight}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="crq-filters-open-section">
              <div className="page-content-inner">
                <div className="crq-filters-controls">
                  <button
                    className="clear-filters-button"
                    type="button"
                    onClick={this.clearFilters}
                  >
                    <RefreshIcon />
                    <span>Clear Filters</span>
                  </button>
                  <button
                    type="button"
                    // className="apply-filters-button"
                    className={`apply-filters-button-${enableFilterBtn ? 'active' : 'inActive'}`}
                    onClick={this.applyFilters}
                    disabled={!enableFilterBtn}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="page-content-inner">
            <div className="crq-filters-closed">
              <div className="crq-filter-title-tags">
                {title && (
                  <div className="crq-filter-title">
                    {title}
                  </div>
                )}
                <CrqListFilterTags
                  selectedStatuses={selectedStatuses}
                  selectedSlas={selectedSlas}
                  selectedReason={selectedReason}
                  selectedDate={selectedDate}
                  selectedEndDate={selectedEndDate}
                  selectedRaisedDate={selectedRaisedDate}
                  selectedMyCRQ={this.state.selectedMyCRQ}
                  selectedFlight={this.state.selectedFlight}
                  clearDate={this.clearDateTag}
                  clearEndDate={this.clearEndDateTag}
                  clearRaisedDate={this.clearRaisedDateTag}
                  clearStatus={this.clearStatusTag}
                  clearSla={this.clearSlaTag}
                  clearMyCRQ={this.clearMyCRQ}
                  clearFlight={this.clearFlight}
                  clearSelectedReason={this.clearSelectedReason}
                />
              </div>
              <button
                className="open-fiters-button"
                type="button"
                onClick={this.openPanel}
              >
                <FiltersIcon />
                Filters
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const FilterPropsShape = PropTypes.shape({
  statuses: PropTypes.array,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  raisedDate: PropTypes.instanceOf(Date),
  selectedSlas: PropTypes.array,
  isMyCRQSelected: PropTypes.bool,
  isFlightSelected: PropTypes.bool,
});

CrqListFilters.propTypes = {
  currentFilters: FilterPropsShape,
  setFilters: PropTypes.func,
  showStatuses: PropTypes.bool,
  listIsSearch: PropTypes.bool,
  title: PropTypes.element,
};

export { CrqListFilters, FilterPropsShape };
